import React, { useEffect } from 'react';
import './SupportGuide.css';

const SupportGuide = () => {
    useEffect(() => {
        const searchInput = document.getElementById('ruleSearch');
        const ruleItems = document.querySelectorAll('.supportguide-rule');

        const filterRules = (searchTerm) => {
            const query = searchTerm.toLowerCase().trim();
            ruleItems.forEach(item => {
                const itemText = item.textContent.toLowerCase();
                if (itemText.includes(query)) {
                    item.style.display = 'block';
                } else {
                    item.style.display = 'none';
                }
            });
        };

        const handleKeyUp = (e) => {
            filterRules(e.target.value);
        };

        if (searchInput) {
            searchInput.addEventListener('keyup', handleKeyUp);
        }

        return () => {
            if (searchInput) {
                searchInput.removeEventListener('keyup', handleKeyUp);
            }
        };
    }, []);

    return (
        <div className="supportguide-container">
            <div className="supportguide-card">
                <div className="supportguide-card-header">
                    <div className="supportguide-card-header-icon">
                        <i className="fas fa-headset"></i>
                    </div>
                    <h3>Support Leitfaden</h3>
                </div>

                <div className="supportguide-card-body">
                    <div className="supportguide-info">
                        <strong>Hallo Liebes Team,</strong><br />
                        Hier findet man einen allgemeinen Leitfaden für den Support zum Nachschlagen.
                    </div>

                    <div className="supportguide-search">
                        <input
                            type="text"
                            className="supportguide-search-input"
                            id="ruleSearch"
                            placeholder="Regeln filtern (z.B. 'Strafen', 'Entbannung', 'IC')"
                        />
                    </div>

                    <div className="supportguide-divider"></div>

                    <div className="supportguide-rules" id="rulesContainer">
                        <div className="supportguide-rule">
                            <div className="supportguide-rule-title">
                                <div className="supportguide-rule-title-icon">
                                    <i className="fas fa-comments"></i>
                                </div>
                                Verhalten im Support
                            </div>
                            <ul>
                                <li>Begrüßt die Spieler <strong>respektvoll</strong> und <strong>nett</strong> im Support und fragt, wie man diesen weiterhelfen kann.</li>
                                <li>Sollte es sein, dass eine Person im Support ist, mit der du nicht gut klarkommst, dann zieh lieber eine anderen Supporter dazu und dieser übernimmt den Fall.</li>
                                <li>Werde <strong>niemals</strong> laut im Support oder schreit die Spieler an. Bevor es dazu kommt, holt lieber einen anderen Supporter dazu. Habt den Supportfall zwar unter Kontrolle, aber werdet nicht ausfällig.</li>
                                <li>Behandelt unsere Spieler so, wie ihr auch behandelt werden möchtet.</li>
                                <li>Eure <strong>persönliche Meinung</strong> über Spieler hat in Support-Fällen nichts zu suchen.</li>
                                <li>Bei Nicht-Einhaltung wird streng <strong>sanktioniert</strong>.</li>
                            </ul>
                        </div>

                        <div className="supportguide-rule">
                            <div className="supportguide-rule-title">
                                <div className="supportguide-rule-title-icon">
                                    <i className="fas fa-share-square"></i>
                                </div>
                                Support-Weiterleitung
                            </div>
                            <p>Wenn ihr eine Person im Warteraum habt, die z.B. mit <strong>@PL</strong> dort ist, zieht diese Person bitte dennoch. Fragt nach, ob ihr helfen könnt.</p>
                            <p>Wenn nicht, fragt bitte nach dem <strong>Grund</strong>, weshalb Sie mit der Person sprechen möchten und schreibt den Grund hinter dem Namen.</p>
                            <p><strong>Beispiel:</strong> @Jordan - Beschwerde</p>
                        </div>

                        <div className="supportguide-rule">
                            <div className="supportguide-rule-title">
                                <div className="supportguide-rule-title-icon">
                                    <i className="fas fa-gavel"></i>
                                </div>
                                Strafen für Spieler
                            </div>
                            <ul>
                                <li>Bitte achtet darauf, den <strong>Strafenkatalog</strong> zu beachten und ihn nur als Grundlage zu nehmen.</li>
                                <li>Permanente Bans werden nicht zu früh und schnell ausgesprochen!</li>
                                <li>Ihr könnt Strafen auch in Fällen milder aussprechen, z.B. wenn die Person sehr einsichtig ist.</li>
                                <li>Guckt ebenfalls die History der Spieler an und auch die Spielzeit und spricht dementsprechend auch die Strafen aus (z.B. Viel Spielzeit, Keine harten Vergehen = milderen Strafen; Kaum Spielzeit, Viele Banns und Warns = härtere Strafe)</li>
                            </ul>
                        </div>

                        <div className="supportguide-rule">
                            <div className="supportguide-rule-title">
                                <div className="supportguide-rule-title-icon">
                                    <i className="fas fa-user-shield"></i>
                                </div>
                                Strafen ohne Rücksprache
                            </div>
                            <p>Wenn ihr einen Supportfall habt und die "Täter" noch auf dem <strong>Server</strong> sind, dann hat der Spieler das <strong>Recht</strong>, sich im Support dazu zu äußern, im Idealfall mit einem Clip.</p>
                            <p>Jede Person hat das Recht, sich zu <strong>verteidigen</strong>! Schreibt die Person bitte per <strong>DM</strong> an oder gebt ihm einen <strong>Warn</strong>, dass er sich im Support einfinden soll. Oftmals sieht die andere Seite nochmals ganz anders aus.</p>
                        </div>

                        <div className="supportguide-rule">
                            <div className="supportguide-rule-title">
                                <div className="supportguide-rule-title-icon">
                                    <i className="fas fa-gamepad"></i>
                                </div>
                                IC und OOC
                            </div>
                            <ul>
                                <li>Ihr seid entweder im Support als <strong>Teamler</strong> oder IC als RP <strong>Spieler</strong> unterwegs. Dies darf nicht vermischt werden.</li>
                                <li>Eure IC Rechte haben nichts im RP verloren. <strong>Kein Noclip</strong>, <strong>keine Nametags</strong> etc.</li>
                                <li>Keiner außer dem <strong>High Team</strong> (in Sonderfällen) greift in aktive RP Situationen ein.</li>
                                <li>Keiner läuft im <strong>Aduty</strong> durch die Gegend.</li>
                                <li>Wenn euch jemand im RP als Teamler erkennt, gebt ihr der Person einen Warn.</li>
                                <li>Wenn euch eine Situation nicht legit vorkommt, spielt ihr sie aus und geht danach zum Supporter, damit sie euch supporten kann.</li>
                                <li>Die Rechte sind nicht dafür da, dass ihr euch im RP einen Vorteil verschaffen könnt.</li>
                            </ul>
                        </div>

                        <div className="supportguide-rule">
                            <div className="supportguide-rule-title">
                                <div className="supportguide-rule-title-icon">
                                    <i className="fas fa-hand-holding-heart"></i>
                                </div>
                                Eigensupport
                            </div>
                            <ul>
                                <li>Es ist verboten, <strong>eigene Fraktionsmitglieder</strong> wiederzubeleben. Dies fällt unter <strong>Eigensupport</strong> und wird dementsprechend bestraft.</li>
                                <li>Ebenso wenn euch Spieler z.B. aus der eigenen Fraktion IC ansprechen, ob ihr nicht mal schnell einen <strong>resetchar</strong> geben könnt. Auch das fällt unter <strong>Eigensupport</strong>!</li>
                                <li>Solltet ihr einen Supportfall ziehen, der in irgendeiner Art mit eurer Fraktion zusammenhängt, gebt diesen Fall bitte an einen anderen Teamler weiter.</li>
                            </ul>
                        </div>

                        <div className="supportguide-rule">
                            <div className="supportguide-rule-title">
                                <div className="supportguide-rule-title-icon">
                                    <i className="fas fa-video"></i>
                                </div>
                                Aufnahmepflicht/Sicherheitsbans
                            </div>
                            <p>Supporter, die keinen <strong>Analysten-Rang</strong> haben, dürfen keine <strong>Aufnahmepflicht verhängen</strong> sowie keine <strong>Aufnahmepflicht aufheben</strong>. Außerdem dürfen Sie keinen <strong>Sicherheitsban</strong> ohne Rücksprache mit einem <strong>Analysten</strong> ausführen.</p>
                        </div>

                        <div className="supportguide-rule">
                            <div className="supportguide-rule-title">
                                <div className="supportguide-rule-title-icon">
                                    <i className="fas fa-eye"></i>
                                </div>
                                Überwachung
                            </div>
                            <p>Achtet <strong>eigenständig</strong> darauf, dass nicht mehrere Teamler gleichzeitig einen <strong>Hotspot</strong> überwachen, sondern schaut nach und teilt euch auf die verschiedenen Hotspots auf. Es wird nur überwacht, wenn der <strong>Discord-Support</strong> läuft und auch Tickets bearbeitet sind - <strong>vernachlässigt</strong> diese Bereiche bitte nicht!</p>
                            <p>Die <strong>Fraktionsverwaltung</strong> ist zuständig für die Überwachung von Situationen der Fraktionen. Sollten diese in einer Situation Unterstützung brauchen, werden sie sich melden!</p>
                        </div>

                        <div className="supportguide-rule">
                            <div className="supportguide-rule-title">
                                <div className="supportguide-rule-title-icon">
                                    <i className="fas fa-ban"></i>
                                </div>
                                Entbannungen
                            </div>
                            <ul>
                                <li>Ihr dürft weder einen <strong>Bann aufheben</strong>, noch einen <strong>Ban verkürzen</strong>. Auch nicht, wenn der Ban von euch kommt (Ausnahme: Fehlban).</li>
                                <li>Bitte fragt die Spieler, ob diese bereits ein <strong>Entbannungsticket</strong> geöffnet haben. Ist dies nicht der Fall, verweist bitte auf das <strong>Ticketsystem</strong>!</li>
                                <li>Nur die Entbannungsverwaltung kann Bans aufheben und verkürzen.</li>
                            </ul>
                        </div>

                        <div className="supportguide-rule">
                            <div className="supportguide-rule-title">
                                <div className="supportguide-rule-title-icon">
                                    <i className="fas fa-undo-alt"></i>
                                </div>
                                Rückerstattungen
                            </div>
                            <p>Rückerstattungen werden nur von der <strong>Rückerstattungsverwaltung</strong> entschieden. Bitte macht in den <strong>Supportgesprächen</strong> keine Versprechungen.</p>
                            <p>Die Spieler sollen ein <strong>Ticket</strong> eröffnen mit einem entsprechenden Clip. Wenn kein Clip vorhanden ist, bekommt der Spieler auch keine Rückerstattung.</p>
                        </div>

                        <div className="supportguide-rule">
                            <div className="supportguide-rule-title">
                                <div className="supportguide-rule-title-icon">
                                    <i className="fas fa-users-cog"></i>
                                </div>
                                Wann muss die Fraktionsverwaltung hinzugezogen werden?
                            </div>
                            <ul>
                                <li>Es sind <strong>mind. 6 Personen</strong> einer Fraktion daran beteiligt</li>
                                <li>Eine Fraktion äußert einen <strong>Meta</strong> Verdacht gegenüber einer anderen Fraktion</li>
                                <li>Baseraids</li>
                                <li>Kriegsverträge</li>
                                <li>Routen</li>
                                <li>Gangwars</li>
                            </ul>
                        </div>

                        <div className="supportguide-rule">
                            <div className="supportguide-rule-title">
                                <div className="supportguide-rule-title-icon">
                                    <i className="fas fa-pen-alt"></i>
                                </div>
                                Namensänderungen
                            </div>
                            <p className="supportguide-rule-subtitle">Wann kann ich eine Namensänderung machen?</p>
                            <ul>
                                <li>wenn eine Namensänderung <strong>gerechtfertigt</strong> ist (z.B. Eintritt/Austritt Fraktion)</li>
                                <li>Wenn nur der Char geändert werden soll, könnt ihr auch <strong>/skinchanger ID</strong> nutzen!</li>
                            </ul>
                        </div>

                        <div className="supportguide-rule">
                            <div className="supportguide-rule-title">
                                <div className="supportguide-rule-title-icon">
                                    <i className="fas fa-ticket-alt"></i>
                                </div>
                                Tickets
                            </div>
                            <p className="supportguide-rule-subtitle">Altersüberprüfung:</p>
                            <p>Bei Unsicherheiten übernimmt vorerst das High Team die Altersüberprüfung per Ticket!</p>
                            <p className="supportguide-rule-subtitle">Teamler in Tickets:</p>
                            <ul>
                                <li>Bitte bearbeitet die Tickets <strong>nicht mit mehreren Teamlern</strong>, dies wird unübersichtlich!</li>
                                <li>Wenn ihr ein Ticket anfangt, solltet ihr es auch <strong>zu Ende führen</strong> und es liegt in eurer <strong>Verantwortung</strong>.</li>
                                <li>Gerne könnt ihr andere Teamler fragen, solltet ihr im Ticket nicht weiterkommen.</li>
                            </ul>
                            <p className="supportguide-rule-subtitle">Das Umbenennen von Tickets:</p>
                            <p>Nach dem Farbsymbol drückt immer <strong>ein Backspace</strong> zurück, sodass dieser Bindestrich (-) nicht im Namen des Tickets auftaucht.</p>
                            <p>Dies ist zwar nur eine Kleinigkeit, aber es sollte <strong>einheitlich</strong> aussehen.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SupportGuide;
